import { ReactNode } from 'react';

import { styled } from '../../../../styled';

const StatusWrapper = styled(({ className, children }: { className: string; children: ReactNode }) => (
	<div className={className}>{children}</div>
))({ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', paddingRight: 0 });

export { StatusWrapper };
